export default "__VITE_ASSET__$ljHdxyL__"